module.exports = __webpack_public_path__ + "img/report-viewer-light.15a89c8c.svg";